export default class ValidatorResult {
    // #region Properties
    isSucceeded = false;
    message;
    // #endregion
    // #region Constructor
    constructor(isSucceeded, message) {
        this.isSucceeded = isSucceeded;
        this.message = message;
    }
}
